import { JSONObject } from '~/components/payment-beta/types';
import currencyFormatter from '~/libs/currency-formatter';
import getLocale from '~/libs/locale';

import { SKIP_AMOUNT_SUGGESTION_KEY } from './constants';

export const skipAmountSuggestion = () => window.sessionStorage.getItem(SKIP_AMOUNT_SUGGESTION_KEY) === 'true';

export type PAGData = {
	amount: number;
	methodId: number;
	oneButtonFlow: boolean;
};

export const getPAGdata = (): PAGData | null => {
	const URLqueryParams = new URLSearchParams(window.location.search).get('sidebar');
	const data = URLqueryParams?.includes('pag') ? URLqueryParams.split('pag=').pop() : '';

	try {
		const result = (data ? JSON.parse(data) : false) as JSONObject;

		return result
			? {
					amount: Math.floor(Number(result?.amount)),
					methodId: Number(result?.methodId),
					oneButtonFlow: result?.oneButtonFlow === 'true'
				}
			: null;
	} catch (_) {
		return null;
	}
};

export const formatAmount = (amount?: string | number, currency?: string, loc = '') => {
	if (!currency) {
		return null;
	}

	const locale = loc || getLocale() || 'en_GB';
	const formatted = currencyFormatter.format(amount, currency, locale) as string;

	return formatted;
};

export const browserInfo = {
	language: navigator.language,
	timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
	width: window.screen.width,
	height: window.screen.height,
	colorDepth: window.screen.colorDepth,
	pixelDepth: window.screen.pixelDepth,
	pixelRatio: window.devicePixelRatio || 1,
	viewportHeight: document.documentElement?.clientHeight,
	viewportWidth: document.documentElement?.clientWidth,
	javascriptEnabled: true
};
